import { render, staticRenderFns } from "./AssignJudges.vue?vue&type=template&id=5e9a68d8"
import script from "./AssignJudges.vue?vue&type=script&lang=js"
export * from "./AssignJudges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports